module.exports = __webpack_public_path__ + "img/roles_10.fe84e33f.png";